





























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficePreAnestesicoStore from '@/components/Backoffice/Store/BackofficePreAnestesicoStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import ReservaDeSangueStore from '@/components/SolicitacaoCirurgia/store/ReservaDeSangueStore'
import SolicitacaoComentariosStore from '@/components/SolicitacaoComentarios/Store/SolicitacaoComentariosStore'
import { timeout, humanTime, onlyNumber, formatDateOnly, maskPhone, displayColorBySituation, displayColorByStatus, getHospitalAreaName } from '@/utils/common'
import { AgendamentoCirurgia, StatusSlaEnum, IRequestMessage, RequestMessage, Loading, LembreteEnum, PreAnestesicoEnum, AgendamentoSolicitacaoItem } from '@/types/_'
import { IPreAnestesia, PreAnestesia } from '@/types/implements/PreAnestesia'
import moment from 'moment'

/** EventBus */
import EventBus from '@/plugins/EventBus'
import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'

@Component({ filters: { humanTime } })

export default class ViewBackofficePreAnestesico extends Vue {
  $refs!: {
    cirurgiaDe: any,
  }

  hTime(s: string) {
    return humanTime(s)
  }

  displayDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'Sem previsão'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'Nova data solicitada'
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    if (item.dataAgendamentoVirtual) return 'Data virtual'
    if (item.dataAgendamento) return this.hTime(item.dataAgendamento)
    if (item.opcaoDataPrevisto1) return this.hTime(item.opcaoDataPrevisto1)
    return 'Sem previsão'
  }

  formatDataAgendamento(item: any) {
    if (item.situacao.key === 'Cancelada') return 'bold__text--grey'
    if (item.situacaoData.key === 'NovaDataSolicitada') return 'bold__text--orange'
    if (item.situacaoData.key === 'SemData') return 'bold__text--light-grey'
    if (item.dataAgendamentoVirtual) return 'bold__text--yellow'
    if (item.dataAgendamento) return 'bold__text--grey'
    if (item.opcaoDataPrevisto1) return 'bold__text--red'
    return 'bold__text--grey'
  }

  readyState: boolean = false
  loadRealizarAvaliacao: string = ''
  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'Item particular', value: 'temItemParticular', sortable: false, active: true },
    { text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false, active: true },
    { text: 'Situação', value: 'situacao', sortable: false, active: true },
    { text: 'Reserva de sangue', value: 'temReservaSangue', sortable: false, active: true },
    { text: 'Status Pré-anestésico', value: 'statusAvaliacaoPreAnestesia', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    // { text: 'Mensagem', value: '', sortable: false, active: true },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
  ]

  preAnestesia: IPreAnestesia = new PreAnestesia()
  getRequestMessage: IRequestMessage = new RequestMessage()
  areaDoHospital: any = getHospitalAreaName()

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  get loadingRealizarAvaliacao() {
    return this.loadRealizarAvaliacao
  }

  set loadingRealizarAvaliacao(value: string) {
    this.loadRealizarAvaliacao = value
  }

  columnSelectionMenu: boolean = false

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-pre-anestesico-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-pre-anestesico-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficePreAnestesicoStore.loadAgendamentosMedicoSearch()
    this.readyState = true
    this.getTableHeaders()
    this.clearLoadingRequest()
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getReservaDeSangueStore() {
    return getModule(ReservaDeSangueStore, this.$store)
  }

  get getBackofficePreAnestesicoStore() {
    return getModule(BackofficePreAnestesicoStore, this.$store)
  }

  get solicitacoes() {
    return this.getBackofficePreAnestesicoStore.solicitacoes
  }

  get drawer() {
    return this.getBackofficePreAnestesicoStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficePreAnestesicoStore.setFilterDrawer(value)
  }

  get etapa() {
    return this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesiaQuery
  }

  set etapa(value: any) {
    this.getBackofficePreAnestesicoStore.setStatusAvaliacaoPreAnestesiaQuery(value.key)
  }

  get etapas() {
    return [
      { key: 'Pendente', display: 'Pendente consulta', quantidade: this.getPendenteTotal },
      { key: 'Apto', display: 'Apto', quantidade: this.getAptoTotal },
      { key: 'AptoComAtencao', display: 'Apto com atenção', quantidade: this.getAptoComAtencaoTotal },
      { key: 'NaoApto', display: 'Não apto', quantidade: this.getNaoAptoTotal },
    ]
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    if (this.getAllEtapas) return 'mdi-checkbox-marked'
    if (this.getSomeEtapas) return 'mdi-minus-box'
    return 'mdi-checkbox-blank-outline'
  }

  get todosOsStatus() {
    return this.getBackofficePreAnestesicoStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.getBackofficePreAnestesicoStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.getBackofficePreAnestesicoStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.getBackofficePreAnestesicoStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  selectAllFromHospital() {
    this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
    })
  }

  selectAllFromArea() {
    this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
    })
  }

  selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.getBackofficePreAnestesicoStore.clearStatusAvaliacaoPreAnestesiaQuery()
    }
    this.etapa = item
  }

  async filterSituacao() {
    this.getBackofficePreAnestesicoStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getBackofficePreAnestesicoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getPendenteTotal() {
    if (this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.length > 0
      && this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.Pendente).length > 0) {
      return this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.Pendente)[0].quantidade
    }
    return 0
  }

  get getAptoTotal() {
    if (this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.some(c => c.key === PreAnestesicoEnum.Apto
      && this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(d => d.key === PreAnestesicoEnum.Apto).length > 0)) {
      return this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.Apto)[0].quantidade
    }
    return 0
  }

  get getAptoComAtencaoTotal() {
    if (this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.some(c => c.key === PreAnestesicoEnum.AptoComAtencao)
      && this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.AptoComAtencao)[0].quantidade) {
      return this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.AptoComAtencao)[0].quantidade
    }
    return 0
  }

  get getNaoAptoTotal() {
    if (this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.some(c => c.key === PreAnestesicoEnum.NaoApto)
      && this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.NaoApto).length > 0) {
      return this.getBackofficePreAnestesicoStore.statusAvaliacaoPreAnestesia.filter(c => c.key === PreAnestesicoEnum.NaoApto)[0].quantidade
    }
    return 0
  }

  get getTotal() {
    return this.getBackofficePreAnestesicoStore.totalSolicitacoes || 0
  }

  displayReserva(item: any) {
    if (item.situacaoData.key === 'SemData') return 'Sem data definida'
    return item.numeroAgendamento || 'Sem reserva'
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  async clearAdvancedFilters() {
    this.getBackofficePreAnestesicoStore.clearFiltro()
    this.getBackofficePreAnestesicoStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    this.clearLoadingRequest()
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.jaPassouPorEsteStatus) {
      classes.push('backoffice-list-table-row__japassouporessestatus')
    }

    if (data.carater.key === 'Urgencia') {
      classes.push('backoffice-list-table-row__urgencia')
    }

    return classes
  }

  async realizarAvaliacao(item: AgendamentoCirurgia) {
    this.loadingRealizarAvaliacao = item.id

    const response = await this.preAnestesia.bloquearSolicitacao(item.id)
    if (response.success) {
      await this.getBackofficeGlobalStore.closeModalRealizarAvaliacao()
      const request = await this.getBackofficeGlobalStore.getSolicitacaoById(item.id)
      if (request.success) {
        await this.getReservaDeSangueStore.getReservaDeSangue(item.id)
        await this.getBackofficeGlobalStore.getHospitalTemplate(item.hospitalId)

        this.getBackofficeGlobalStore.setModal({ name: 'realizarAvaliacao', value: true })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: request.message, icon: 'warning', color: '#C62828' })
      }
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message, icon: 'warning', color: '#C62828' })
    }

    this.loadingRealizarAvaliacao = ''
  }

  /**
   * ========== COMENTÁRIO E LEMBRETE ==========
   */

  get getComentariosStore() {
    return getModule(SolicitacaoComentariosStore, this.$store)
  }

  async showComentario(agendamentoMedico) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    const solicitacaoId = agendamentoMedico.id || ''
    await this.getComentariosStore.getComentariosBySolicitacaoId(solicitacaoId)
    this.getComentariosStore.setShowModalComentario(true)
    this.clearLoadingRequest()
  }

  /**
   * ========== PAGINAÇÃO ==========
   */

  get getPagina() {
    return this.getBackofficePreAnestesicoStore.pagina
  }

  set getPagina(value: number) {
    this.getBackofficePreAnestesicoStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.getBackofficePreAnestesicoStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.getBackofficePreAnestesicoStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.getBackofficePreAnestesicoStore.totalSolicitacoes
  }

  get agendamentoLength() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  modDe: boolean = false

  get de() {
    return this.getBackofficePreAnestesicoStore.deFiltro
  }

  set de(value: Date | string | null) {
    this.getBackofficePreAnestesicoStore.setDeFiltro(value)
  }

  get formattedDe() {
    return this.formatDateRange(this.de)
  }

  get modalDe() {
    return this.modDe
  }

  set modalDe(value: boolean) {
    this.modDe = value
  }

  formatDateRange(date: Date | string | null) {
    if (!date) return null
    const [year, month, day] = date.toString().split('-')
    return `${day}/${month}/${year}`
  }

  resetModalDe() {
    this.de = null
    this.modalDe = false
  }

  minDate(date: string) {
    if (!date) return null
    const min = moment(date).add(1, 'day').format('YYYY-MM-DD')
    return min
  }

  maxDate(date: string) {
    if (!date) return null
    const max = moment(date).add(1, 'year').format('YYYY-MM-DD')
    return max
  }

  clearDate(field: string) {
    if (field === 'de') {
      this.de = null
    }
  }

  async getResults(pagina: number) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getPagina = pagina
    await this.getBackofficePreAnestesicoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  async mounted() {
    this.de = moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD')
    await this.init()
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async getAllBackofficeSolicitacoes() {
    this.loadingAllSolicitacoes = true
    const response = await this.getBackofficePreAnestesicoStore.loadAgendamentosMedicoSearch()
    if (!response.success) EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    this.loadingAllSolicitacoes = false
  }

  beforeDestroy() {
    this.getBackofficePreAnestesicoStore.clearFiltro()
    this.getBackofficePreAnestesicoStore.setFilterOn(false)
    this.getBackofficePreAnestesicoStore.setTodosOsStatus(false)
    this.getBackofficePreAnestesicoStore.setTodosOsStatusDaArea(false)
    this.getBackofficePreAnestesicoStore.resetStatusAvaliacaoPreAnestesiaQuery()
    this.getBackofficeGlobalStore.setBackofficeArea('')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }
}
